export function getInvitationsBackNavigation(returnToSecureChat, explorerDestination) {
    if (returnToSecureChat) {
        return {
            destination: explorerDestination,
            labelKey: "magicLink.navigation.backToSecureChat",
            options: { state: { openSecureChat: true } },
        };
    }
    return {
        destination: explorerDestination,
        labelKey: "magicLink.navigation.explorer",
    };
}
